import { Stack } from '@mui/material';
import { BenchmarkFleet } from '../components';

const BenchmarkRoute = () => {
    return (
        <Stack direction={'column'}>
            <BenchmarkFleet />
        </Stack>
    );
};

export default BenchmarkRoute;
